<template>

    <h3>涨停股票</h3>

    <!-- 查询区域 -->
    <div class="query-section">
      <div class="query-row">
        <label class="label" for="date-picker">选择日期:</label>
        <el-date-picker
          id="date-picker"
          v-model="date"
          type="date"
          placeholder="选择日期"
          :default-value="new Date()"
          @change="fetchData"
          class="date-picker"
          aria-label="选择查询日期"
        ></el-date-picker>
      </div>

      <div class="query-row">
        <label class="label" for="search-input">输入关键字:</label>
        <input
          id="search-input"
          type="text"
          v-model="searchQuery"
          class="input-field"
          @keyup.enter="fetchData"
          aria-label="输入股票名称或代码进行搜索"
        />
      </div>

      <!-- 选项区域 -->
      <el-header class="options-header">
        <el-radio-group v-model="selectedOption" @change="changeAgency">
          <el-radio-button
            v-for="option in p_options"
            :key="option.value || option"
            :label="option.value || option"
          >
            {{ option.label || option }}
          </el-radio-button>
        </el-radio-group>
      </el-header>

      <button
        @click="fetchData"
        class="button update-stock-button"
        :disabled="isSubmitting"
        aria-label="查询涨停股票数据"
      >
        {{ isSubmitting ? '加载中...' : '查看' }}
      </button>
    </div>

    <!-- 错误提示 -->
    <div v-if="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>

    <!-- 数据展示区域 -->
    <div v-if="wencaiData && wencaiData.data && wencaiData.data.length > 0" class="result-container">
      <child-component :response-data="wencaiData" @fetch-data="fetchData" />
    </div>
    <div v-else-if="!errorMessage && !isSubmitting" class="no-data">
      没有找到相关数据，请检查输入条件
    </div>

</template>

<script>
import axios from 'axios';
import ChildComponent from '@/components/ChildComponent.vue';
import { formatDate, getPreviousDate } from '@/utils/commonMethods';

export default {
  components: {
    ChildComponent
  },
  data() {
    return {
      date: getPreviousDate(),
      searchQuery: '',
      selectedOption: '炒股养家',
      p_options: [],
      wencaiData: {},
      isSubmitting: false,
      errorMessage: '',
      searchTimer: null
    };
  },
  computed: {
    formattedDate() {
      return this.date ? formatDate(this.date) : '';
    }
  },
  methods: {
    // 获取机构列表
    async agency_all() {
      try {
        const response = await axios.get(`/api/agency_all`);

        // 处理机构数据，确保格式统一
        if (Array.isArray(response.data)) {
          this.p_options = response.data.map(item =>
            typeof item === 'string' ? { label: item, value: item } : item
          );

          // 设置默认选中的选项
          if (this.p_options.length > 0 &&
              !this.p_options.some(option => option.value === this.selectedOption)) {
            this.selectedOption = this.p_options[0].value;
          }
        } else {
          this.errorMessage = '机构数据格式错误';
        }
      } catch (error) {
        console.error('请求失败:', error);
        this.errorMessage = '机构数据加载失败';
      }
    },

    // 防抖处理搜索
    debouncedFetch() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.fetchData();
      }, 300);
    },

    // 获取数据
    async fetchData() {
      if (this.isSubmitting) return;
      this.errorMessage = '';
      this.isSubmitting = true;

      try {
        const response = await axios.get(`/api/toplevel`, {
          params: {
            date: this.formattedDate,
            searchQuery: this.searchQuery,
            agency: this.selectedOption
          }
        });

        const responseData = response.data;
        console.log(responseData);

        // 验证响应数据结构
        if (!responseData || typeof responseData !== 'object') {
          throw new Error('无效的响应数据');
        }

        // 提取数据和表头
        const selectedData = responseData['data'];
        const headers = ["代码", "名称", "相关", "日期", "营业部买入额_万_", "营业部卖出额_万_", "买卖净额_万_", "上榜原因",
               '上榜后1日', '上榜后2日', '上榜后3日', '上榜后5日', '上榜后10日', '上榜后20日', '上榜后30日'];

        // 验证数据有效性
        console.log(selectedData, headers);
        if (!Array.isArray(selectedData) || !Array.isArray(headers)) {
          throw new Error('数据格式不正确');
        }

        // 构造传递给子组件的数据
        this.wencaiData = {
          title: `涨停股票 - ${this.selectedOption}`,
          data: selectedData,
          headers: headers
        };

      } catch (error) {
        console.error('数据获取失败:', error);
        this.errorMessage = '数据加载失败，请检查网络连接';
        this.wencaiData = null;
      } finally {
        this.isSubmitting = false;
      }
    },

    // 机构切换事件
    changeAgency(option) {
      this.selectedOption = option.value || option;
      this.fetchData();
    }
  },
  mounted() {
    this.agency_all().then(() => {
      this.fetchData();
    });
  }
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #333;
}

.query-section {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
}

.query-row {
  margin-bottom: 16px;
}

.date-picker,
.input-field {
  width: 100%;
}

.input-field {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}

.options-header {
  margin: 24px 0;
  background-color: #f5f7fa;
  padding: 16px;
  border-radius: 6px;
}

.button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;
}

.button:hover {
  background-color: #0069d9;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.error-message {
  color: #dc3545;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.no-data {
  color: #666;
  background-color: #e9ecef;
  border: 1px solid #dee2e6;
  padding: 12px;
  border-radius: 4px;
  margin-top: 20px;
}

.result-container {
  margin-top: 20px;
}

@media (max-width: 768px) {
  .container {
    padding: 10px;
  }

  .input-field, .date-picker {
    width: 100%;
  }
}
</style>
